import { Reveal } from "../Reveal";
import { useLang } from "@/i18n";

const Section = ({ title, children }) => (
  <Reveal>
    <div className="border-t border-[#1A1B18]/10 pt-8">
      <h2 className="font-modern text-xl md:text-2xl font-medium tracking-tight mb-4">{title}</h2>
      <div className="text-sm md:text-base text-[#1A1B18]/70 leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

export default function CondizioniVendita() {
  const { lang } = useLang();
  return (
    <div className="v2-modern bg-[#FAF9F6] text-[#1A1B18] min-h-screen">
      <header className="border-b border-[#1A1B18]/10">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <a href="/" data-testid="condizioni-logo" className="font-modern text-xl md:text-2xl font-semibold tracking-tight">
            Stylottica Ceglie
          </a>
          <a
            href="/"
            data-testid="condizioni-back"
            className="rounded-full border border-[#1A1B18]/30 text-[10px] uppercase tracking-[0.15em] px-4 py-2 hover:bg-[#1A1B18] hover:text-white transition-colors duration-300"
          >
            {lang === "it" ? "Torna al sito" : "Back to site"}
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#A86946] mb-4">Condizioni di Vendita</p>
          <h1 className="font-modern text-4xl md:text-6xl font-medium tracking-tighter leading-[1.05] mb-6">
            Condizioni di vendita
          </h1>
          <p className="text-sm text-[#1A1B18]/50 mb-14">
            Ultimo aggiornamento: settembre 2026 · ai sensi del D.Lgs. 206/2005 ("Codice del Consumo")
          </p>
        </Reveal>

        <div className="space-y-10">
          <Section title="1. Il venditore">
            <p>
              I prodotti presenti su questo sito sono venduti da <strong>Stylottica S.A.S.</strong> (insegna{" "}
              <strong>Stylottica Ceglie</strong>), con sede in Via Cristoforo Colombo 40, 72013 Ceglie Messapica (BR),
              P.IVA 02325720742.
            </p>
            <p>
              Per qualsiasi informazione puoi scriverci a{" "}
              <a href="mailto:infostylottica@libero.it" className="text-[#A86946] underline underline-offset-2">
                infostylottica@libero.it
              </a>
              , chiamare lo{" "}
              <a href="tel:08311981780" className="text-[#A86946] underline underline-offset-2">0831 19 81 780</a>{" "}
              o contattarci su{" "}
              <a
                href="https://wa.me/393925218114"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#A86946] underline underline-offset-2"
              >
                WhatsApp
              </a>.
            </p>
          </Section>

          <Section title="2. Prodotti e prezzi">
            <p>
              Le immagini e le descrizioni dei prodotti hanno finalità illustrativa; lievi differenze di colore o
              dettaglio rispetto all'originale sono possibili. La disponibilità degli articoli viene sempre confermata
              al momento dell'ordine.
            </p>
            <p>
              Tutti i prezzi indicati sono espressi in Euro e <strong>si intendono IVA inclusa</strong>. Eventuali costi
              di spedizione, ove applicabili, sono comunicati e concordati prima della conferma dell'ordine.
            </p>
          </Section>

          <Section title="3. Come effettuare un ordine">
            <p>
              Puoi aggiungere gli articoli al carrello e inviare la tua richiesta d'ordine tramite il sito. L'ordine
              viene quindi <strong>finalizzato tramite WhatsApp o telefono</strong>, dove concordiamo insieme la
              disponibilità, le modalità di consegna e il pagamento.
            </p>
            <p>
              La proposta d'ordine inviata dal cliente non costituisce vendita conclusa: il contratto si perfeziona con
              la <strong>conferma da parte di Stylottica Ceglie</strong>. Ci riserviamo di non accettare ordini
              incompleti, non disponibili o con dati non corretti.
            </p>
          </Section>

          <Section title="4. Modalità di consegna: spedizione o ritiro in sede">
            <p>Dopo l'ordine puoi scegliere, d'accordo con noi via WhatsApp, tra due modalità:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Ritiro in negozio:</strong> gratuito, presso il punto vendita di Via Cristoforo Colombo 40,
                Ceglie Messapica (BR), previa comunicazione della disponibilità.
              </li>
              <li>
                <strong>Spedizione:</strong> tramite corriere all'indirizzo indicato dal cliente; tempi e costi vengono
                comunicati e concordati prima della conferma. I tempi di consegna sono indicativi e possono variare in
                base al vettore e alla lavorazione (in particolare per gli occhiali con lenti su misura).
              </li>
            </ul>
          </Section>

          <Section title="5. Pagamento">
            <p>
              Il pagamento avviene <strong>in negozio al ritiro</strong> oppure con le modalità concordate al momento
              dell'ordine (es. bonifico o link di pagamento sicuro condiviso via WhatsApp). Il sito{" "}
              <strong>non raccoglie né conserva i dati delle carte di pagamento</strong>.
            </p>
          </Section>

          <Section title="6. Diritto di recesso (reso entro 14 giorni)">
            <p>
              Se sei un consumatore e hai acquistato con <strong>spedizione a distanza</strong>, hai diritto di recedere
              dall'acquisto <strong>entro 14 giorni</strong> dal ricevimento del prodotto, senza doverne indicare il
              motivo, ai sensi degli artt. 52 e ss. del Codice del Consumo.
            </p>
            <p>
              Per esercitare il recesso è sufficiente comunicarcelo via email o WhatsApp e restituire l'articolo integro,
              non utilizzato e nella confezione originale. Il costo della restituzione è a carico del cliente. Ti
              rimborseremo entro 14 giorni dal ricevimento del reso o della prova di spedizione.
            </p>
            <p>
              <strong>Eccezioni:</strong> il diritto di recesso non si applica ai prodotti confezionati o realizzati
              <strong> su misura o personalizzati</strong> — in particolare occhiali con lenti graduate montate su
              misura — né, per motivi igienici, alle <strong>lenti a contatto</strong> con confezione aperta (art. 59
              Codice del Consumo). Il ritiro e la prova in negozio non rientrano nelle vendite a distanza.
            </p>
          </Section>

          <Section title="7. Garanzia legale di conformità">
            <p>
              Tutti i prodotti sono coperti dalla <strong>garanzia legale di conformità di 24 mesi</strong> prevista dal
              Codice del Consumo. In caso di difetto di conformità hai diritto al ripristino della conformità (riparazione
              o sostituzione) o, nei casi previsti, a una riduzione del prezzo o alla risoluzione del contratto. Conserva
              lo scontrino o la fattura come prova d'acquisto.
            </p>
          </Section>

          <Section title="8. Reclami e risoluzione delle controversie">
            <p>
              Per qualsiasi reclamo puoi contattarci a{" "}
              <a href="mailto:infostylottica@libero.it" className="text-[#A86946] underline underline-offset-2">
                infostylottica@libero.it
              </a>
              . Cercheremo sempre una soluzione bonaria. In alternativa, la Commissione Europea mette a disposizione la
              piattaforma di risoluzione online delle controversie (ODR):{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#A86946] underline underline-offset-2"
              >
                ec.europa.eu/consumers/odr
              </a>
              .
            </p>
          </Section>

          <Section title="9. Legge applicabile">
            <p>
              Le presenti condizioni sono regolate dalla legge italiana. Per il consumatore restano ferme le tutele
              inderogabili previste dalla legge del suo paese di residenza e la competenza del foro del consumatore.
            </p>
          </Section>
        </div>
      </main>

      <footer className="border-t border-[#1A1B18]/10">
        <div className="max-w-4xl mx-auto px-6 py-8 text-xs text-[#1A1B18]/40">
          © {new Date().getFullYear()} Stylottica Ceglie · Stylottica S.A.S. · Ceglie Messapica
        </div>
      </footer>
    </div>
  );
}
